"use strict";
/*
 * Created on 25. 3. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractReleaseConverterImpl_1 = require("../AbstractReleaseConverterImpl");
/**
 * @author Radek Beran
 */


var SelloutReleaseConverter =
/*#__PURE__*/
function (_AbstractReleaseConve) {
  _inherits(SelloutReleaseConverter, _AbstractReleaseConve);

  function SelloutReleaseConverter(releasePartConverter, selloutReleasePartConverter, userInfoConverter, editInfoConverter, validationResultConverter, realImpactValueConverter, selloutItemFilterConverter, selloutReleaseSnapshotConverter) {
    var _this;

    _classCallCheck(this, SelloutReleaseConverter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseConverter).call(this, releasePartConverter, selloutReleasePartConverter, userInfoConverter, editInfoConverter, validationResultConverter, realImpactValueConverter, selloutItemFilterConverter, selloutReleaseSnapshotConverter));
    _this.releasePartConverter = releasePartConverter;
    _this.selloutReleasePartConverter = selloutReleasePartConverter;
    _this.userInfoConverter = userInfoConverter;
    _this.editInfoConverter = editInfoConverter;
    _this.validationResultConverter = validationResultConverter;
    _this.realImpactValueConverter = realImpactValueConverter;
    _this.selloutItemFilterConverter = selloutItemFilterConverter;
    _this.selloutReleaseSnapshotConverter = selloutReleaseSnapshotConverter;
    return _this;
  }

  return SelloutReleaseConverter;
}(AbstractReleaseConverterImpl_1.AbstractReleaseConverterImpl);

exports.SelloutReleaseConverter = SelloutReleaseConverter;